/**
 * Is this the phone layout? A thin reading of useViewport, kept so code that
 * only needs the phone/not-phone switch does not have to know about tiers.
 */

import { useViewport } from '@/mobile/useViewport';

export { setViewportOverride } from '@/mobile/useViewport';

export function useIsMobile(): boolean {
  return useViewport() === 'phone';
}
